import axios from "axios";
import { toast } from "react-toastify";
import { RequestBidRevision, BidListApi, BidComaprisonApi } from ".";

export const fetchBids = ({ params }) => {
  return axios
    .get(`${BidListApi}`, { params: { ...params } })
    .then((res) => {
      return res?.data;
    })
    .catch(() => {});
};

export const fetchBidComparison = ({ params }) => {
  return axios
    .get(`${BidComaprisonApi}`, { params: { ...params } })
    .then((res) => {
      return res?.data;
    })
    .catch(() => {});
};

export const createBid = ({ data }) => {
  return axios
    .post(`${BidListApi}`, data)
    .then((res) => {
      return res?.data;
    })
    .catch(() => {
      toast.error("Something went wrong!");
    });
};

export const requestBidRevision = ({ vendor_bid_id, revision_comment }) => {
  const values = new FormData();
  values.append("vendor_bid_id", vendor_bid_id);
  values.append("revision_comment", revision_comment);
  const config = {
    headers: {
      "content-type": "multipart/form-data",
    },
  };
  return axios
    .post(`${RequestBidRevision}`, values, config)
    .then((res) => {
      return res?.data;
    })
    .catch(() => {
      toast.error("Something went wrong!");
    });
};
